<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>

    <div class="row" style="margin-top: 15px; overflow:visible;" *ngIf="!useSpinner">
        <div class="col-md-10 stickyTitle">
        </div>
        <div class="col-md-2">
            <a (click)="onNoClick()" style="cursor: pointer;">
                <mat-icon class="nc-icon-glyph ui-1_simple-remove" style="margin: auto; transform: scale(1.5);">
                </mat-icon>
            </a>
        </div>
    </div>

    <div *ngIf="!useSpinner" style="min-height:200px;">
        <h3 style="text-align:center"><b>{{title}}</b></h3>
        <hr>
        <div class="col-md-12">
            <ng-container *ngIf="textAreaText; else notTextArea">
                <h4><textarea
                        style="min-height: 150px; min-width: 300px; border: 0; background-color: white; resize: none"
                        disabled>{{ warningMessage }}</textarea></h4>
            </ng-container>
            <ng-template #notTextArea>
                <h4 style="text-align:center">{{ warningMessage }}</h4>
            </ng-template>
            <br>

            <ng-container *ngIf="questionTypeDialog === false; else elseTemplate">

                <h4 *ngIf="newTextSet"><textarea
                        style="min-height: 150px; min-width: 450px; border: 1; background-color: white; resize: none; padding-left: 20px;"
                        disabled>{{ newText }}</textarea></h4>

                <div class="col-md-offset-4" style="padding-left: 15px"><button mat-raised-button color="primary"
                        style="width: 80px" class="btn btn-md btn-primary" (click)="onNoClick()">ok</button></div>

            </ng-container>
            <ng-template #elseTemplate>

                <h4 style="color: red;">Required*</h4>
                <h4 *ngIf="newTextSet"><textarea id="userInputTextArea" (input)="monitorTextArea($event.target)"
                        style="min-height: 150px; min-width: 450px; border: 1; background-color: white; resize: none; padding-left: 20px;"
                        required>{{ newText }}</textarea></h4>

                <div id="buttonRow" style="display:inline-block; white-space: nowrap;">
                    <div style="display:inline-block" class="col-md-offset-3 button-row"><button mat-raised-button
                            color="primary" class="btn btn-md btn-primary" (click)="yesButton()" [disabled]="disableYesButton">Yes</button>

                        <div class="divider"></div>

                        <div style="display:inline-block"><button mat-raised-button color="primary"
                                class="btn btn-md btn-primary" (click)="noButton()">No</button>
                        </div>
                    </div>
                </div>

            </ng-template>

        </div>

    </div>

    <div *ngIf="useSpinner" style="padding-left: 40%; padding-top: 15%;">
        <mat-spinner></mat-spinner>
    </div>

</div>